namespace GeniuzPOS.Product {
    export interface CsConceptRow {
        Id?: number;
        ConceptCode?: string;
        ConceptName?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        IsActive?: number;
        FullName?: string;
    }

    export namespace CsConceptRow {
        export const idProperty = 'ConceptCode';
        export const nameProperty = 'FullName';
        export const localTextPrefix = 'Product.CsConcept';
        export const lookupKey = 'Product.CsConcept';

        export function getLookup(): Q.Lookup<CsConceptRow> {
            return Q.getLookup<CsConceptRow>('Product.CsConcept');
        }
        export const deletePermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:Concept:Delete';
        export const insertPermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:Concept:Modify';
        export const readPermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:Concept:View';
        export const updatePermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:Concept:Modify';

        export declare const enum Fields {
            Id = "Id",
            ConceptCode = "ConceptCode",
            ConceptName = "ConceptName",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            IsActive = "IsActive",
            FullName = "FullName"
        }
    }
}
